var app = {
    // functions
    cookies: {
        createCookie: function (name, value, days) {
            _main = app;
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
            document.cookie = name + "=" + value + expires + "; path=/";
            (_main.debug) ? console.log('creating cookie: ', name) : '';
        },
        readCookie: function (name) {
            _main = app;
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },
        checkCookies: function () {
            _main = app;
            if (_main.cookies.readCookie(_main.cookieName) != 1) {
                $('.popCookies').show();
            } else {
                (_main.debug) ? console.log('cookie %s already exists', _main.cookieName) : '';
            }
            $('#cookiesAccept').on('click', function () {
                _main.cookies.createCookie(_main.cookieName, 1, 365);
                $('.popCookies').fadeOut(300, function () {
                    $(this).remove();
                });
            });
        },
    },
    scrollEvents: function () {
        _main = this;
        // pxTop=$(window).scrollTop();
        // if (_main.viewport=='desktop') {            
        //     if (pxTop >= $('section#hero').height()*1.1) {
        //         $('.closeSubPage').css('margin-top', pxTop-$('section#hero').height()*1.1+'px');  
        //     } else {
        //         $('.closeSubPage').css('margin-top', '0px');    
        //     }
        // }
    },
    detectViewport: function () {
        _main = this;
        if ($(window).width() <= _main.breakpointMobile) {
            _main.viewport = 'mobile';
        } else if ($(window).width() > _main.breakpointMobile && $(window).width() <= _main.breakpointTablet) {
            _main.viewport = 'tablet';
        } else if ($(window).width() > _main.breakpointTablet) {
            _main.viewport = 'desktop';
        }
        (_main.debug) ? console.log('viewport: ', _main.viewport) : '';
        if ($('body').attr('id') == 'form') {
            $('input#input_device').val(_main.viewport);
        }
    },
    ga_event: function ($category, $action) {
        _main - this;
        ga('send', 'event', $category, $action, 1);
    },
    scrollTo: function (target) {
        _main = this;
        // switch (target) {
        //     case 'top':
        //         _goto = 0;
        //     break;
        //     case 'content':
        //         _goto = $('#hero').height();
        //     break;
        //     case 'tabs':
        //         _goto = $('#hero').height()-$('.tabsContainer').height();
        //     break;
        // }        
        // $("html, body").animate({
        //     scrollTop: _goto
        // }, "slow"); 
    },
    toggleNav: function () {
        _main = this;
        (_main.debug) ? console.log('mobile nav click') : '';
        (_main.debug) ? console.log('mobileNav: ', _main.mobileNav) : '';
        if (_main.mobileNav === true) {
            (_main.debug) ? console.log('hide nav') : '';
            $('#navIcon').removeClass('fa-close').addClass('fa-navicon');
            _main.mobileNav = false;
            $('header, .topPanel').removeClass('avalible');
        } else if (_main.mobileNav === false) {
            (_main.debug) ? console.log('show nav') : '';
            $('header, .topPanel').addClass('avalible');
            $('#navIcon').removeClass('fa-navicon').addClass('fa-close');
            _main.mobileNav = true;
        }
    },
    updatePrice: function (value) {
        _main = this;
        console.log('updating price');
        var currentPrice = $('#totalPrice').html();
        console.log('current price: ', currentPrice);
        var newPrice = currentPrice - (currentPrice / value * 100);
        console.log('new price: ', newPrice);
        $('#totalPrice').html(newPrice);
    },
    popMessage: function (msg) {
        _main = this;
        $('body').append('<figure class="popMessage">\
            <p>'+ msg + '</p>\
            <div class="closePop">&times;</div>\
        </figure>');
    },
    validateForm: function () {
        _main = this;

        console.log('extra input 1', _main.extraInput);

        if ($('#legal1_accept').val() != 1) {
            $('.inputLike.legal1_accept').addClass('error');
            (_main.debug) ? console.log('not selected: #legal1_accept') : '';
            val1 = false;
        } else {
            val1 = true;
        }
        // if ($('#legal2_accept').val() != 1) {
        //     $('.inputLike.legal2_accept').addClass('error');
        //     (_main.debug) ? console.log('not selected: #legal2_accept') : '';
        //     val2 = false;
        // } else {
        //     val2 = true;
        // }
        if ($('#legal4_accept').val() != 1) {
            $('.inputLike.legal4_accept').addClass('error');
            (_main.debug) ? console.log('not selected: #legal4_accept') : '';
            val3 = false;
        } else {
            val3 = true;
        }

        if ($('#input_title').val() == '0') {
            $('.inputLike.title').addClass('error');
            (_main.debug) ? console.log('not selected: #input_title') : '';
            val4 = false;
        } else {
            val4 = true;
        }
        if ($('#input_days').val() == '0') {
            $('.inputLike.days').addClass('error');
            (_main.debug) ? console.log('not selected: #input_title') : '';
            val5 = false;
        } else {
            val5 = true;
        }
        if ($('#input_firstname').val() == '') {
            $('#input_firstname').addClass('error');
            val9 = false;
        } else {
            val9 = true;
        }
        if ($('#input_lastname').val() == '') {
            $('#input_lastname').addClass('error');
            val10 = false;
        } else {
            val10 = true;
        }
        if ($('#input_email').val() == '') {
            $('#input_email').addClass('error');
            val11 = false;
        } else {
            val11 = true;
        }
        if ($('#input_phone').val() == '') {
            $('#input_phone').addClass('error');
            val12 = false;
        } else {
            val12 = true;
        }

        if ($('#input_business').val() == '0' || $('#input_business').val() === null || $('#input_business').val() === undefined) {
            $('#input_business').parent('.box').addClass('error');
            (_main.debug) ? console.log('not selected: #input_business') : '';
            val6 = false;
        } else {
            val6 = true;
        }
        if ($('#input_role').val() == '0' || $('#input_role').val() === null || $('#input_role').val() === undefined) {
            $('#input_role').parent('.box').addClass('error');
            (_main.debug) ? console.log('not selected: #input_role') : '';
            val7 = false;
        } else {
            val7 = true;
        }
        if ($('#input_option1').val() == '0') {
            $('.inputLike.option1').addClass('error');
            (_main.debug) ? console.log('not selected: #input_option1') : '';
            val8 = false;
        } else {
            val8 = true;
        }

        if (val1 == true && val3 == true && val4 == true && val5 == true && val6 == true && val7 == true && val8 == true && val9 == true && val10 == true && val11 == true && val12 == true) {
            return true;
        } else {
            return false;
        }

    },
    events: function () {
        _main = this;

        $(".scrollTop").click(function () {
            _main.scrollTo('top');
        });

        $('.prevDef').on('click', function (e) {
            e.preventDefault();
        });

        $('.inputRadio').on('click', function () {
            group = $(this).attr('data-input-name');
            $('.inputRadio.' + group).removeClass('selected').removeClass('error');
            $(this).addClass('selected');
            $('#input_' + $(this).attr('data-input-name')).val($(this).attr('data-value'));
            (_main.debug) ? console.log('input name: ', $(this).attr('data-input-name')) : '';
            (_main.debug) ? console.log('input val: ', $(this).attr('data-value')) : '';
        });
        $('#input_business,#input_role').on('change', function () {
            $(this).removeClass('error');
        });
        $('.inputRadioLegal').on('click', function () {
            group = $(this).attr('data-input-name');
            input_name = $(this).attr('data-input-name');
            $(this).toggleClass('selected');
            var state = '0';
            if ($(this).hasClass('selected')) {
                var state = '1';
                $('#' + input_name).val(state);
            } else {
                var state = '0';
                $('#' + input_name).val(state);
            }
            $(this).removeClass('error');

            (_main.debug) ? console.log('input name: ', input_name) : '';
            (_main.debug) ? console.log('input val: ', state) : '';
        });
        $('.inputRadio.days').on('click', function () {
            if ($('#input_days').val() == 1) {
                $('.daysExtra').show();
                _main.extraInput = true;
            } else {
                $('.daysExtra').hide();
                _main.extraInput = false;
            }
        });
        $('#input_business, #input_role').on('change', function () {
            $(this).parent('.box').removeClass('error');
        });

        $('#sendThatForm').on('click', function (e) {
            (_main.debug) ? console.log('sending form') : '';
            // $('#mainButton').click();
            var validation = _main.validateForm();
            if (validation === true) {
                $('#mainButton').click();
                // alert('form ok');
                // $('#form').submit();
            } else {
                $("html, body").animate({
                    scrollTop: $('.error').scrollTop()
                }, "slow");
                (_main.debug) ? console.log('form is not valid') : '';
            }
        });

        $('.legal_container .link').on('click', function () {
            console.log('clicked');
            $(this).prev('').toggleClass('reveal');
        });




        // first try to launch GA event if the button has specific parameters, then launch url
        // *button needs two attributes: data-ga-category, data-ga-action
        // $('.btn').on('click', function (e) {
        //     e.preventDefault();
        //     target = $(this).attr('href');
        //     category = $(this).attr('data-ga-category');
        //     action = $(this).attr('data-ga-action');
        //     if (typeof category !== typeof undefined && category != '' && category !== false && typeof action !== typeof undefined && action != '' && action !== false) {
        //         (_main.debug) ? console.log('GA event launched: %s / %s', category, action) : '';
        //         _main.ga_event(category, action);
        //     } else {
        //         (_main.debug) ? console.log('This button is not tracked with GA') : '';
        //     }
        //     if ($(this).hasClass('prevDef')) {
        //         (_main.debug) ? console.log('ignoring link') : '';
        //     } else {
        //         // window.open(target, '_blank');
        //         window.open(target, '_self');
        //     }
        // });

        // show input for discount code if needed
        $('.ticketType').on('click', function () {
            var thisType = $(this).attr('data-coupon');
            _main.selectedCouponType = thisType;
            (_main.debug) ? console.log('coupon type: ', _main.selectedCouponType) : '';
            if (_main.selectedCouponType != 'n') {
                $('.couponCheckout').show();
            } else {
                $('.couponCheckout').hide();
            }
        });

        // user can has invoice for his ticket
        $('#invoiceControl').on('click', function () {
            $(this).toggleClass('enabled');
            if (_main.debug && $(this).hasClass('enabled')) {
                console.log('invoice needed');
                $('.invoiceDetails').show();
            } else {
                console.log('no invoice');
                $('.invoiceDetails').hide();
            }
        });

        // verify if code is correct
        $('.verifyCoupon').on('click', function (e) {
            e.preventDefault();
            var code = $('#couponCode').val();
            $.ajax({
                url: base_url + "verify/" + _main.selectedCouponType + "/" + code,
            }).done(function (response) {
                console.log('response: ', response);
                if (response.match("^invalid")) {
                    console.log('error: ', response);
                } else {
                    _main.updatePrice(response);
                }
                // alert('response: ',response);
            });
        });

        // toggle mobile navigation
        $('#navTrigger').on('click', function () {
            _main.toggleNav();
        });

        // newsletter
        $('#email').focus(function () {
            $('.termsContainer').addClass('shown');
        });

        $('body').on('click', '.closePop', function () {
            $('.popMessage').remove();
        });

        $('#addEmail').on('submit', function (e) {

            e.preventDefault();

            var errors = false;
            var emailReg = /^([a-zA-Z0-9\\.]+)@([a-zA-Z0-9\\-\\_\\.]+)\.([a-zA-Z0-9]+)$/i;

            if (!errors) {
                $.ajax({
                    type: 'POST',
                    url: base_url + 'get-newsletter',
                    data: {
                        'email_address': $('#email').val()
                    },
                    success: function (msg) {
                        (_main.debug) ? console.log('ajax success: ', msg) : '';
                        if (msg.match("^Error")) {
                            message = 'Wystąpił błąd podczas wysyłania zgłoszenia.'; // request has been sent but returned some kind of error (maybe address is already on the list or something else fucked up)
                        } else {
                            message = 'Dziękujemy. Na podany e-mail zostanie wysłana prośba o potwierdzenie chęci udziału w newsletterze.';
                        }
                        _main.popMessage(message);
                    },
                    error: function (msg) {
                        (_main.debug) ? console.log('ajax error: ', msg) : '';
                        _main.popMessage('Wystąpił błąd podczas wysyłania zgłoszenia.');
                    }
                });
            } else {
                (_main.debug) ? console.log('errors in form') : '';
            }

            $(".errors").remove();

            if ($("#email").val() === "") {
                $("#email").addClass('error');
                errors = true;
            } else if (!emailReg.test($("#email").val())) {
                $("#email").addClass('error');
                errors = true;
            }

            if ($("#terms1").is(':checked')) { } else {
                $("#terms1").addClass('error');
                console.log('terms1 error');
                errors = true;
            }

            if ($("#terms2").is(':checked')) { } else {
                $("#terms2").addClass('error');
                console.log('terms2 error');
                errors = true;
            }
            return !errors;
        });
    },

    // variables
    debug: true,

    viewport: null,
    mobileNav: false,
    selectedCouponType: 'n', // r = reusable, s = single, n = none
    breakpointMobile: 640,
    breakpointTablet: 1200,
    extraInput: false,
    cookieName: 'filmteractive2019website',


    //  initialize
    init: function () {
        app.detectViewport();
        app.events();
        app.cookies.checkCookies();
    }
};

$(document).ready(function () {
    app.init();
});

$(document).scroll(function () {
    // app.scrollEvents();
});


